/*
 * T345: nimetty «ei käyttöoikeutta» -sivu.
 *
 * Piilotettu osoite ohjasi ennen tätä ensimmäiseen näkyvään näkymään
 * hiljaa. Käyttäjä ei siis nähnyt estettä vaan VÄÄRÄN SIVUN: kenttätili
 * pyysi `#/tarjous` ja sai Puutteet, eikä ruudulla ollut mitään mikä
 * kertoisi kumpi tapahtui — ohjaus vai kirjoitusvirhe osoitteessa.
 * Mitattu 18.9.2026 demossa: kenttätili 22 osoitetta 27:stä ja
 * asiakastunnus 9 laskeutuivat toiseen näkymään ilman sanaa.
 *
 * Sivu vastaa kolmeen kysymykseen, joista vain ensimmäinen oli ennen
 * luettavissa: mitä pyysin · miksi en saa sitä · mihin pääsen.
 * Syyn laji on myös koneluettava (`data-esto`), koska kävely ei voi
 * väittää proosasta.
 */
import { t, type KaannosAvain } from "./kieli";

export type Esto = {
  laji: "moduuli" | "rooli" | "rajaus" | "tyolaji" | "oikeus";
  teksti: string;
};

const OTSIKKO: Record<Esto["laji"], KaannosAvain> = {
  moduuli: "esto.moduuli", rooli: "esto.rooli", rajaus: "esto.rajaus", tyolaji: "esto.tyolaji", oikeus: "esto.oikeus",
};

export function EiOikeutta(
  { esto, osoite, nimi, siirto, siirryNimi }:
  { esto: Esto; osoite: string; nimi?: string; siirto: () => void; siirryNimi?: string },
) {
  return (
    <>
      <header className="head">
        <div className="eyebrow">{t("esto.paasy")}</div>
        <div className="head__rivi">
          <h1>{t("esto.otsikko")}</h1>
        </div>
      </header>

      <section className="panel eioikeutta" data-esto={esto.laji}
               data-osoite={osoite} role="alert">
        <div className="panel__head">
          <h2>{t(OTSIKKO[esto.laji])}</h2>
          <span className="hint">{t("esto.osoite")} #/{osoite}</span>
        </div>
        <p>
          {t("esto.pyysit", { nimi: nimi ?? osoite })}
        </p>
        <p className="huom huom--vika">{esto.teksti}</p>
        <p className="huom">
          {t("esto.pyyda")}
        </p>
        {siirryNimi && (
          <div className="lomake__napit">
            <button type="button" className="nappi nappi--paa" onClick={siirto}>
              {t("esto.siirry", { nimi: siirryNimi })}
            </button>
          </div>
        )}
      </section>
    </>
  );
}
